import { render, staticRenderFns } from "./workOrders.vue?vue&type=template&id=99662170"
import script from "./workOrders.vue?vue&type=script&lang=js"
export * from "./workOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports